import t from "../../../helpers/t";
import FormItem from "../../../components/FormItem";
import React, { useState } from "react";

const MembershipTypeSelect = (props) => {
  const { membershipTypes, setMembershipTypes, dispatch } = props;
  const [selectedMembershipTypes, setSelectedMembershipTypes] = useState(membershipTypes);
  /*useEffect(() => {
        change();
    },[membershipTypes]);*/

  const addMembershipTypes = (membershipType) => {
    let membershipTypeIds = [];
    membershipTypeIds.push({
      id: membershipType.id,
      name: membershipType.name,
    });
    setMembershipTypes(membershipTypeIds);
  };
  const change = () => {
    let membershipTypeIds = [];
    selectedMembershipTypes.map((sel) => {
      membershipTypeIds.push({
        id: sel.id,
        name: sel.name,
      });
    });
    setMembershipTypes(membershipTypeIds);
  };

  const onRemoveMembershipType = (index) => {
    const newMembershipTypes = selectedMembershipTypes.slice(0);
    newMembershipTypes.splice(index, 1);
    setSelectedMembershipTypes(newMembershipTypes);
    change();
  };

  const fields = {
    fieldMap: {
      id: {
        label: t("id"),
        number: "1",
        class: "inb-select-width-1",
        type: "default",
        style: { maxWidth: "20%", padding: 0 },
      },
      name: {
        label: t("name"),
        number: "2",
        class: "inb-select-width-3",
        type: "default",
        style: { maxWidth: "35%", padding: 0 },
      },
      description: {
        label: t("description"),
        number: "3",
        class: "inb-select-width-3",
        type: "default",
      },
    },
    fieldNames: ["id", "name", "description"],
  };
  const searchParams = {
    param: "q",
    checkFields: ["name"],
  };
  return (
    <>
      <FormItem
        name="locations"
        type="inboomaSelect"
        id={"membershipTypesSelect"}
        sortBy={"name"}
        sortDirection={"asc"}
        advanced={true}
        placeholder={t("select_${a}", { a: t("usergroup", null, "capital") })}
        selectedItems={selectedMembershipTypes}
        setSelectedItems={setSelectedMembershipTypes}
        onChangeHandler={addMembershipTypes}
        dispatch={dispatch}
        container="membershipType-vcard"
        extraStyle={{ maxWidth: "750px" }}
        multiSelect={true}
        onReset={onRemoveMembershipType}
        fields={fields}
        searchParams={searchParams}
        model={"membershipType"}
        label={t("usergroups", null, "capital") + " " + t("which will be used for temporary user")}
        mediumWidth={12}
        smallWidth={12}
      />
    </>
  );
};
export default MembershipTypeSelect;
